import styled from 'styled-components/macro';

export const PageWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 0 1.5rem;
  box-sizing: content-box;
`;
